module.exports = __webpack_public_path__ + "static/media/heypixi-logo.1bfe8b93.png";